import React from 'react'
import styled from 'styled-components'
import { ReactComponent as QuizDiagnosticsSvg } from 'assets/Quiz-Diagnostics.svg'

type QuizDiagnosticsIconProps = {
  width?: string
  height?: string
}

export const QuizDiagnosticsIcon = ({
  width = '20px',
  height = '20px'
}: QuizDiagnosticsIconProps): JSX.Element => (
  <IconRoot $width={width} $height={height}>
    <QuizDiagnosticsSvg aria-hidden />
  </IconRoot>
)

const IconRoot = styled.span<{ $width: string; $height: string }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${({ $width }) => $width};
  height: ${({ $height }) => $height};
  color: inherit;

  svg {
    width: 100%;
    height: 100%;
  }

  path {
    fill: currentColor;
    stroke: currentColor;
  }
`

export default QuizDiagnosticsIcon
